var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary mr-3 print-button",domProps:{"innerHTML":_vm._s(_vm.loading ? _vm.spin() : _vm.ic('download') + ' Export PDF')},on:{"click":_vm.action}})
}
var staticRenderFns = []

export { render, staticRenderFns }